import React, { Component } from 'react'

var data = require('./db.json');

class UpdateInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      updateDate: ""
    }
  }

  componentDidMount() {
    this.setState({
      updateInfo: data.updateInfo[0].text
    })
  }

  render() {
    return (
      <div className="update-info">
        Desenvolvido por Claudio Bitar<br />        
        {this.state.updateInfo}
    </div>
    )
  }
}

export default UpdateInfo




// WEBPACK FOOTER //
// ./src/UpdateInfo.js